pageId = 'page-lanhu-designs'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.initFileViews()

  $('.files-view.list-view .design').on 'click', (e) ->
    if not tower.me.admin
      return

    $target = $(e.target)
    if $target.is('a') || $target.closest('a').length > 0
      return

    e.preventDefault()
    $item = $(@)
    $view = $item.closest('.files-view')
    baseSelected = $view.data('base-selected')

    if e.shiftKey
      lastSelected = baseSelected[baseSelected.length - 1]
      if baseSelected.length < 1
        $item.addClass('selected')
        baseSelected.push($item[0])
      else if lastSelected is $item[0]
        $item.parent('.file-list').children().removeClass('selected')
        $(baseSelected).addClass('selected')
      else
        $items = $item.parent('.file-list').children().removeClass('selected')
        if $items.index($item) > $items.index(lastSelected)
          $item.prevUntil(lastSelected) \
            .addBack() \
            .addClass('selected')
        else
          $item.nextUntil(lastSelected) \
            .addBack() \
            .addClass('selected')
        $(baseSelected).addClass('selected')

    else if tower.metaKey(e)
      if $item.hasClass('selected')
        $item.removeClass('selected')
        index = $.inArray($item[0], baseSelected)
        if index > -1
          baseSelected.splice(index, 1)

      else
        $item.addClass('selected')
        baseSelected.push($item[0])

    else
      $item.addClass('selected') \
        .siblings('.design') \
        .removeClass('selected')
      baseSelected.length = 0
      baseSelected.push($item[0])

    refreshSelectedDesigns()

  $('.link-lanhu-move, .link-move-designs').on 'click', (e) ->
    e.preventDefault()
    e.stopPropagation()

    $link = $(@)
    items = $link.data('items')
    $dialog = $ $('#tpl-lanhu-dialog').html()
    tower.initSelectProj($dialog, false)

    dialog = simple.dialog
      content: $dialog
      width: 450
      modal: true
      buttons: null

    $dialog.find('.form-change').attr('action', $link.data('move-url'))
    $dialog.find('.form-change .name').text($link.data('name'))

    $dialog.find('.btn-cancel-move').on 'click', (e) ->
      dialog.remove()

    $dialog.on 'ajax:beforeSend', (e, xhr, settings) ->
      $form = $(@)
      $input = $form.find('.select-choose-projects input:last')
      isKanban = $form.find('.select-choose-projects').data('select').selectItem()?.is_kanban
      valid = true

      if !$input.val()
        $form.find('.select-result:first').addClass 'error'
        valid = false

      unless valid
        $btn = $form.find('button[type=submit]')
        $btn.text $btn.data('ujs:enableWith')
          .prop 'disabled', false
          .trigger('blur')
        return false

      settings.data = "#{settings.data}&resources=#{JSON.stringify(items)}" if items

    $dialog.on 'ajax:success', (e, result) ->
      if $link.parent().is('.selected-info')
        $view = $link.closest('.files-view')
        $view.find('.file-list .design.selected').remove()

        refreshSelectedDesigns()

        baseSelected = $view.data('base-selected')
        baseSelected.length = 0
      else
        $link.closest('.design').fadeOut 'fast', ->
          $(@).remove()

      dialog.remove()


  $('.design .link-delete').on 'ajax:success', (e, result) ->
    if result.success
      $(@).closest('.design').fadeOut 'fast', ->
        $(@).remove()


refreshSelectedDesigns = ->
  $selected = $('.files-view .design.selected')
  selectedCount = $selected.length
  if selectedCount > 0
    items = []

    $selected.each (i, el) ->
      $el = $(el)
      items.push($el.data('guid'))

    $('.selected-info').show() \
      .find('.selected-count em') \
      .text(selectedCount) \
      .end() \
      .find('.link-move-designs') \
      .data('name', selectedCount + '项') \
      .data('items', items)

  else
    $('.selected-info').hide() \
      .find('.selected-count em') \
      .text('0') \
      .end() \
      .find('.link-move-designs') \
      .removeData('name') \
      .removeData('items')


